import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/objectWithoutProperties";
const _excluded = ["application", "applicationStatus", "lastConsolidatedRequest"],
  _excluded2 = ["metadata"],
  _excluded3 = ["metadata"];
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _entriesInstanceProperty from "@babel/runtime-corejs3/core-js/instance/entries";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
import Vue from "vue";
import moment from "moment";
import { INSERT_APPLICATION_GROUP_ITEM, MARK_APPLICATION_AS_SUBMITTED, MARK_PAGE_AS_SUBMITTED, REMOVE_APPLICATION_GROUP_ITEM, REMOVE_APPLICATION_PAGE_DATA, SET_APPLICATION, SET_APPLICATION_DETAILS, SET_DISCLAIMERS, SET_EMPTY_APPLICATION, SET_RAW_SCHEMA, SET_SCHEMA, UPDATE_FIELD, MARK_APPLICATION_GROUP_VISIBILITY, SET_APPLICATION_VALIDATIONS, SET_CONSOLIDATED_REQUEST, SET_RAW_APPLICATION, SET_APPLICATION_VUELIDATIONS } from "./application-mutations";
import { getApplication, getDisclaimers, getFullSIN, getSchema, submitApplication, updateApplication, getApplicationValidations, getApplicationsFromSubdomain, createNewApplication } from "../api/application-api";
import ApplicationGenerator from "../../../../../shared/utils/application-generator";
import { normalize } from "normalizr";
import { pagesSchema } from "./schema";
import { removeEmptyKeys } from "../../../../../shared/utils/utils";
import Err from "@Client/@Routes/error";
import { applicationsSchema } from "./application-schema";
import i18n from "@Shared/@i18n";
import Amplitude from "@Shared/@Utils/amplitude";
import { cloneDeep, get, isEmpty } from "lodash";
import ApplicationValidationsGenerator from "@Shared/@Utils/application-validation-generator";
import { DEFAULT_DISCLAIMER_ID } from "@Shared/js/constants";
export const PARSE_APPLICATION = "PARSE_APPLICATION";
export const UPDATE_APPLICATION = "UPDATE_APPLICATION";
export const PARSE_SCHEMA = "PARSE_SCHEMA";
export const ADD_APPLICATION_GROUP = "ADD_APPLICATION_GROUP";
export const REMOVE_APPLICATION_GROUP = "REMOVE_APPLICATION_GROUP";
export const REMOVE_APPLICATION_PAGE = "REMOVE_APPLICATION_PAGE";
export const SUBMIT_APPLICATION = "SUBMIT_APPLICATION";
export const LOAD_DISCLAIMERS = "LOAD_DISCLAIMERS";
export const LOAD_CLIENT_DATA = "LOAD_CLIENT_DATA";
export const LOAD_EMPTY_APPLICATION = "LOAD_EMPTY_APPLICATION";
export const SHOW_FULL_SIN = "SHOW_FULL_SIN";
export const CLEAR_ALL_SINS = "CLEAR_ALL_SINS"; //Holy Sacred Spanish Inquisition
export const SET_APPLICATION_GROUP_ITEM = "SET_APPLICATION_GROUP_ITEM";
export const LOAD_APPLICATION_VALIDATION = "LOAD_APPLICATION_VALIDATION";
export const LOAD_APPLICATIONS_FROM_SUBDOMAIN = "LOAD_APPLICATIONS_FROM_SUBDOMAIN";
export const SET_APPLICATIONS = "SET_APPLICATIONS";
export const LOAD_RAW_SCHEMA = "LOAD_RAW_SCHEMA";
export const LOAD_RAW_APPLICATION = "LOAD_RAW_APPLICATION";
export const CREATE_NEW_APPLICATION = "CREATE_NEW_APPLICATION";
export default {
  /**
   * Load an empty version of the application to the store
   * takes the rawSchema to generate the empty application
   *
   * Depends upon:
   *  - LOAD_RAW_SCHEMA being called before this action
   */
  [LOAD_EMPTY_APPLICATION]: (context, {
    flow
  }) => {
    let emptyApplication = cloneDeep(context.state.emptyApplication[flow]);
    if (isEmpty(removeEmptyKeys(emptyApplication))) {
      let schema = context.state.rawSchema;
      const generator = new ApplicationGenerator(schema);
      const {
        application: generatedApplication
      } = generator.buildApp(flow);
      emptyApplication = generatedApplication;
      context.commit(SET_EMPTY_APPLICATION, {
        flow: flow,
        emptyApplication
      });
      const validationsGenerator = new ApplicationValidationsGenerator(schema);
      const {
        application: applicationValidations
      } = validationsGenerator.buildAppValidations(flow);
      context.commit(SET_APPLICATION_VUELIDATIONS, {
        validations: applicationValidations
      });
    }
  },
  /**
   * Load the full application data into a temp key in the store (rawApplication)
   * this way we can loading and use if before loading the actual state.application
   * and the state.applicationDetails, the place to use all other application data
   * flow, status, etc.
   *
   * this state.rawApplication will be later used by PARSE_APPLICATION and cleared after
   * this action.
   */
  [LOAD_RAW_APPLICATION]: async (context, {
    applicationId,
    agentUsername = null,
    brokerageId = null
  }) => {
    const _await$getApplication = await getApplication(applicationId, agentUsername, brokerageId),
      {
        application = {},
        applicationStatus,
        lastConsolidatedRequest
      } = _await$getApplication,
      appData = _objectWithoutProperties(_await$getApplication, _excluded);
    context.commit(SET_CONSOLIDATED_REQUEST, {
      consolidatedRequest: lastConsolidatedRequest
    });
    context.commit(SET_RAW_APPLICATION, _objectSpread(_objectSpread({}, application), {}, {
      applicationStatus,
      locked: appData.locked
    }));
    context.commit(SET_APPLICATION_DETAILS, _objectSpread(_objectSpread({}, appData), {}, {
      applicationStatus,
      flow: application.flow
    }));
  },
  /**
   * Takes the rawApplication data, parses and loads the application
   * data into the store
   */
  [PARSE_APPLICATION]: async context => {
    context.commit(SET_APPLICATION, context.state.rawApplication);
  },
  [LOAD_DISCLAIMERS]: async context => {
    const {
      disclaimers,
      defaultDisclaimerEnabled
    } = await getDisclaimers();
    const onlyDisclaimers = _filterInstanceProperty(disclaimers).call(disclaimers, ({
      consent
    }) => !consent);
    const isDefaultDisclaimerEnabled = defaultDisclaimerEnabled != null ? defaultDisclaimerEnabled : onlyDisclaimers.length === 1;
    const enabledDisclaimers = _filterInstanceProperty(disclaimers).call(disclaimers, ({
      id,
      enabled = false
    }) => enabled || id === DEFAULT_DISCLAIMER_ID && isDefaultDisclaimerEnabled);
    context.commit(SET_DISCLAIMERS, {
      disclaimers: enabledDisclaimers
    });
  },
  [UPDATE_APPLICATION]: async (context, {
    page,
    ignoreSubmitted,
    applicationId
  }) => {
    try {
      if (page && !ignoreSubmitted) {
        context.commit(MARK_PAGE_AS_SUBMITTED, {
          page
        });
      }
      const currentApplication = context.state.application;
      const isApplicationEmpty = _Object$keys(currentApplication).length === 0;
      if (!isApplicationEmpty) {
        await updateApplication(cloneDeep(context.state.application), applicationId);
        context.commit(SET_APPLICATION_DETAILS, {
          updatedAt: moment().format()
        });
        Amplitude.logEvent("Application - application updated");
      }
    } catch (error) {
      if (page) {
        context.commit(MARK_PAGE_AS_SUBMITTED, {
          page,
          submitted: false
        });
      }
      throw error;
    }
  },
  [SUBMIT_APPLICATION]: async (context, {
    applicationId
  }) => {
    const {
      acceptedConsents = {},
      disclaimers
    } = context.state;
    const acceptedConsentsIds = _Object$keys(acceptedConsents);
    const consentObtained = disclaimers.some(disclaimer => disclaimer.consent);
    await submitApplication(consentObtained, acceptedConsentsIds, applicationId);
    context.commit(MARK_APPLICATION_AS_SUBMITTED, {
      isConsolidatedRequest: context.getters["IS_CONSOLIDATED_REQUEST"],
      applicationId
    });
    Amplitude.logEvent("Application - application submitted");
  },
  /**
   * Load a raw version of the schema from the backend
   * to the vuex store
   */
  [LOAD_RAW_SCHEMA]: async (context, {
    subdomain
  } = {}) => {
    const _await$getSchema = await getSchema(subdomain),
      {
        metadata
      } = _await$getSchema,
      schema = _objectWithoutProperties(_await$getSchema, _excluded2);
    context.commit(SET_RAW_SCHEMA, {
      schema: _objectSpread(_objectSpread({}, schema), {}, {
        metadata
      }),
      fillOutSections: context.getters["CONSOLIDATED_REQUEST_SECTIONS"],
      isConsolidatedRequest: context.getters["IS_CONSOLIDATED_REQUEST"]
    });
  },
  /**
   * Load and Parse the rawSchema saved in the store
   *
   * Depends upon:
   *  - LOAD_RAW_SCHEMA being called before this action
   */
  [PARSE_SCHEMA]: async (context, {
    flow
  } = {}) => {
    const _context$state$rawSch = context.state.rawSchema,
      {
        metadata
      } = _context$state$rawSch,
      schema = _objectWithoutProperties(_context$state$rawSch, _excluded3);
    const currentFlow = flow || context.getters["APPLICATION_DETAILS_FLOW"];
    if (currentFlow) {
      const {
        entities,
        result
      } = normalize(schema[currentFlow], [pagesSchema]);
      context.commit(SET_SCHEMA, {
        metadata,
        pages: {
          byKey: _objectSpread(_objectSpread({}, entities.pages), {}, {
            summary: {
              key: "summary",
              label: i18n.t("application.pages.main-tabs.review"),
              title: i18n.t("application.pages.main-tabs.summary"),
              "body-text": i18n.t("application.messages.pleaseReview")
            }
          }),
          allKeys: [...result, "summary"]
        }
      });
    }
  },
  [ADD_APPLICATION_GROUP]: async (context, {
    what,
    where,
    markAsVisible,
    startEmpty
  }) => {
    if (startEmpty && markAsVisible) {
      context.commit(SET_APPLICATION_GROUP_ITEM, {
        what,
        where
      });
      return context.commit(MARK_APPLICATION_GROUP_VISIBILITY, {
        where,
        visibility: true
      });
    }
    context.commit(INSERT_APPLICATION_GROUP_ITEM, {
      what,
      where
    });
  },
  [REMOVE_APPLICATION_GROUP]: async (context, {
    where,
    index,
    startEmpty
  }) => {
    context.commit(REMOVE_APPLICATION_GROUP_ITEM, {
      where,
      index,
      startEmpty
    });
  },
  [REMOVE_APPLICATION_PAGE]: async (context, {
    page
  }) => {
    context.commit(REMOVE_APPLICATION_PAGE_DATA, {
      page
    });
  },
  [SHOW_FULL_SIN]: async (context, {
    applicantIndex
  }) => {
    const session = Vue.auth.session.get();
    const {
      selectedApplicationId
    } = session;
    const path = applicantIndex === 0 ? "main-applicant" : `co-applicants[${applicantIndex - 1}]`;
    const currentSIN = get(context.state.application, `${path}[personal-details][sin]`);
    let sin = [];
    if (currentSIN && currentSIN[3] !== "XXX") {
      sin = {
        1: currentSIN[1],
        2: currentSIN[2],
        3: currentSIN[3]
      };
    } else {
      ({
        sin
      } = await getFullSIN(applicantIndex, selectedApplicationId));
    }
    context.commit(UPDATE_FIELD, {
      path: `${path}[personal-details]`,
      key: "sin",
      value: sin
    });
  },
  [CREATE_NEW_APPLICATION]: (context, {
    currentSubdomain,
    brokerageId,
    fromClient
  }) => {
    return createNewApplication(currentSubdomain, brokerageId, fromClient);
  },
  [CLEAR_ALL_SINS]: async context => {
    const mainApplicantPath = "main-applicant[personal-details]";
    const currentMainApplicantSIN = get(context.state.application, `${mainApplicantPath}[sin]`);
    const isFilledSIN = !!currentMainApplicantSIN[1];
    context.commit(UPDATE_FIELD, {
      path: mainApplicantPath,
      key: "sin",
      value: {
        1: currentMainApplicantSIN[1],
        2: isFilledSIN ? "XXX" : "",
        3: isFilledSIN ? "XXX" : ""
      }
    });
    const coapps = get(context.state.application, "co-applicants");
    for (const [index, coapp] of _entriesInstanceProperty(coapps).call(coapps)) {
      const currentCoappSIN = coapp["personal-details"]["sin"];
      const isFilledSIN = !!currentCoappSIN[1];
      context.commit(UPDATE_FIELD, {
        path: `co-applicants[${index}][personal-details]`,
        key: "sin",
        value: {
          1: currentCoappSIN[1],
          2: isFilledSIN ? "XXX" : "",
          3: isFilledSIN ? "XXX" : ""
        }
      });
    }
  },
  [LOAD_APPLICATION_VALIDATION]: async (context, {
    applicationId
  }) => {
    try {
      const {
        errors
      } = await getApplicationValidations(applicationId);
      context.commit(SET_APPLICATION_VALIDATIONS, {
        errors
      });
    } catch (e) {
      Err.handle(e);
    }
  },
  [LOAD_APPLICATIONS_FROM_SUBDOMAIN]: async context => {
    try {
      const {
        applicationIds
      } = await getApplicationsFromSubdomain();
      const {
        entities,
        result
      } = normalize(applicationIds, [applicationsSchema]);
      context.commit(SET_APPLICATIONS, {
        applications: {
          byId: entities.applications || {},
          allIds: result
        }
      });
    } catch (e) {
      Err.handle(e);
    }
  }
};